import template from './component.tpl.html';
import AlGuestlistEditorStudioComponentController from './controller';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-guestlist-editor
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-guestlist-editor-page-studio guestlist="{}"></al-guestlist-editor-page-studio>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alGuestlistEditorPageStudio', {
        bindings: {
            guestlist: '<',
            onModelUpdate: '&',
            globalModel: '<',
            showContent: '<'
        },
        controller: AlGuestlistEditorStudioComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/pages/studio/component.js